// HELPERS
import {_} from 'locale';
import fetch from 'isomorphic-unfetch';
import classNames from 'classnames';

// COMPONENTS
import Link from 'next/link';
import {Formik, Form, Field} from 'formik';

// STYLES
import layoutStyles from '../../styles/layout.css';
import styles from './styles.css';

export const shouldRenderError = meta => !!meta.error && !!meta.touched;

export const SimpleField = ({name, label, type="text", children}) => (
    <Field name={name}>
        {({field, meta}) => {
            const className = classNames(styles.field, {
                [styles.error]: shouldRenderError(meta),
                [styles.checkbox]: type === 'checkbox',
            });

            return (
                <div className={className}>
                    <label className={styles.label}>
                        {!!label && <div>{label}</div>}
                        {type == 'textarea'
                            ? <textarea {...field} />
                            : <input type={type} {...field} />
                        }
                        {type == 'checkbox' && <div className={styles.check} />}
                        {children}
                    </label>
                    {/*
                        {shouldRenderError(meta) && (
                            <div className={styles.error}>
                                {meta.error}
                            </div>
                        )}
                    */}
                </div>
            );
        }}
    </Field>
);

export const FileField = ({name, setFieldValue}) => (
    <Field name={name}>
        {({field, meta})=> {
            const {value, ...newField} = field;
            const onChange = ({currentTarget}) => setFieldValue(name, currentTarget.files[0]);
            return (
                <div className={classNames(styles.fileField, {[styles.error]: shouldRenderError(meta)})}>
                    <label className={styles.label}>
                        <input {...newField} type='file' onChange={onChange} />
                        <div>
                            <div className={styles.fileName}>
                                {!value ? _('Selecciona un archivo') : value.name}
                            </div>
                            <div className={layoutStyles.buttonPrimary}>
                                {_('Adjuntar')}
                            </div>
                        </div>
                    </label>
                </div>
        )}}
    </Field>
)

export const SuccessMessage = ({message, next}) => (
    <div className={styles.successMessage}>
        {message}
        {next && (
            <Link href={next}>
                <a className={classNames(styles.next, layoutStyles.buttonPrimary, layoutStyles.fill)}>
                    {_('volver')}
                </a>
            </Link>
        )}
    </div>
);

export const createSubmitHandler = (endpoint) => {
    return async (formValues, formikProps) => {
        const formData =  new FormData();

        const data = {};
        Object.entries(formValues).forEach(([key, value]) => {
            if (value instanceof File) return formData.append(`files.${key}`, value, value.name);
            data[key] = value;
        });

        formData.append('data', JSON.stringify(data));

        const error = _('Hubo un error procesando la inscripción. Por favor, inténtalo de nuevo más tarde.');
        const success = _('Alea iacta est! Tu candidatura se ha enviado correctamente. Si todo está bien te llegará un mail de confirmación. Gracias!');

        try {
            const response = await fetch(`${process.browser ? '' : process.env.SERVER_SIDE_CMS_URL}${endpoint}`, {
                method:'POST',
                body: formData,
            });

            if (!response.ok) return formikProps.setStatus({error});
            return formikProps.setStatus({success});
        } catch(error) {
            formikProps.setStatus({error});
        }
    }
};
